import * as Uniform from "../Webgl/Uniform";
import Webgl from "./Webgl";
import { IS_SERVER } from '@af-app/config';

export default class CanvasWrapper {
	public static instances:CanvasWrapper[] = [];

	public static flush = () => {
		for(let i = 0; i < CanvasWrapper.instances.length; i++){
			CanvasWrapper.instances[i].delete();
		}
		CanvasWrapper.instances = [];
	}

	protected _canvas: HTMLCanvasElement;
	protected _context: WebGLRenderingContext | WebGL2RenderingContext;
	protected _width: number;
	protected _height: number;

	public webgl: Webgl;

	constructor(width?: number, height?: number) {
		this.initContext(width, height);
		this._width = width;
		this._height = height;
		CanvasWrapper.instances.push(this);
	}

	public initContext(width:number, height:number):void {
		this._canvas = document.createElement('canvas');
		this._canvas.width = width;
		this._canvas.height = height;

		this._context = this._canvas.getContext("webgl2", { preserveDrawingBuffer: true, premultipliedAlpha: true });

		if (!this._context) {
			this._context = this._canvas.getContext("webgl", { preserveDrawingBuffer: true, premultipliedAlpha: true });
		}

		if (!this._context) {
			this._context = this._canvas.getContext("experimental-webgl", { preserveDrawingBuffer: true, premultipliedAlpha: true }) as WebGLRenderingContext;
		}
	}

	get width() { return this._width }
	set width(width: number) { this.resize(width, this._height) }

	get height() { return this._height }
	set height(height: number) { this.resize(this._width, height) }

	get context() { return this._context }

	get canvas(): HTMLCanvasElement | void {
		return this._canvas;
	}

	get content(): TexImageSource {
		return this._canvas;
	}

	public resize = (width: number, height: number) => {
		this._canvas.width = width;
		this._canvas.height = height;

		this._width = width;
		this._height = height;
	}

	public delete = () => {
		CanvasWrapper.instances = CanvasWrapper.instances.filter((wrapper) => wrapper !== this);
		delete this._canvas;
		delete this._context;
	}
}